import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, PlutoLogo, ProgressWrapper, PlutoProgressBar } from '../styles/loading';

function LoadingLogo({ visible, className }) {
  return (
    <Wrapper visible={visible}>
      <div>
        <PlutoLogo alt="Pluto TV logo" path="images/logo-new-colored.svg" />
      </div>
      <ProgressWrapper className={className}>
        <PlutoProgressBar alt="Pluto TV progress" path="images/plutoLinearProgress-v5.gif" />
      </ProgressWrapper>
    </Wrapper>
  );
}

LoadingLogo.propTypes = {
  visible: PropTypes.bool,
  className: PropTypes.string,
};

LoadingLogo.defaultProps = {
  visible: true,
  className: null,
};

export default LoadingLogo;
